module.exports = __webpack_public_path__ + "media/images/ac_templates/201/roy-580644b310dc129842f88d3516f20fb5.jpg";